/**
 * Replays the Lucky Duck's arrival on every add to cart.
 *
 * This exists because CSS alone cannot do it. Dawn's cart notification only
 * re-renders three regions — cart-notification-product,
 * cart-notification-button and cart-icon-bubble — and the duck sits in the
 * heading, outside all of them. So the element persists for the life of the
 * page. Dawn's open() then calls classList.add('active'), which changes
 * nothing when the notification is already open, so an animation keyed to
 * that class plays once per page and never again. Adding a second item
 * without dismissing the first would be silent.
 *
 * Restarting an animation requires removing the class, forcing a reflow so
 * the browser registers the change, then adding it back.
 *
 * Nothing here touches the cart. The duck is a non-interactive <img> outside
 * every region Dawn replaces, so this cannot interfere with the DOM swap
 * that actually delivers the cart update.
 */

(() => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  const replay = () => {
    const duck = document.querySelector('#cart-notification .cart-duck');
    if (!duck) return;

    duck.classList.remove('cart-duck--arrive');
    // Forces a reflow. Without it the browser coalesces the remove and add
    // into no change at all, and the animation does not restart.
    void duck.offsetWidth;
    duck.classList.add('cart-duck--arrive');
  };

  subscribe(PUB_SUB_EVENTS.cartUpdate, replay);
})();
